let resolveInitPromise;
let rejectInitPromise;
// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

export default function init(apiKey) {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (!!window.google) return initPromise;

  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window["gmapsCallback"] = () => resolveInitPromise(window.google);

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  const script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.id = "gmapsScript";
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=gmapsCallback&libraries=places`;
  script.onerror = rejectInitPromise;
  document.querySelector("head").appendChild(script);
  return initPromise;
}



// WEBPACK FOOTER //
// ./src/components/Tools/gmaps.js